<template>
	<SlickList
		v-show="list.length > 0"
		:value="list"
		axis="xy"
		@input="onInput"
		class="list"
	>
		<SlickItem
			v-for="(item, idx) in list"
			:key="item.idProduct"
			:index="idx"
			class="list__item"
		>
			<div class="list__product">
				<img :src="item.image" class="list__product-img" />
				<p class="list__product-title" v-text="item.title" />
				<button
					tabindex="0"
					@click="removeProduct(item)"
					class="list__remove-button"
				/>
			</div>
		</SlickItem>
	</SlickList>
</template>
<script>
	import { SlickList, SlickItem } from 'vue-slicksort';

	export default {
		name: 'EditorPickFormProducts',
		components: {
			SlickList,
			SlickItem,
		},
		props: {
			list: {
				type: Array,
				default: [],
			},
		},
		methods: {
			removeProduct(item) {
				if (!confirm(`${item.title} 제품을 삭제 하시겠습니까?`)) return;
				this.$emit('remove', item.idProduct);
			},
			onInput(newList) {
				this.$emit('sortEnd', newList);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.list {
		overflow-x: auto;
		position: relative;
		display: flex;
		width: 1202px;
		margin: auto;
		border: 1px solid #dfe6ef;
		border-radius: 4px;

		&__item {
			position: relative;
			display: block;
			width: 20%;
			min-width: 150px;
			text-align: center;
			flex-shrink: 0;
		}

		&__product {
			font-size: 1rem;
		}

		&__product-img {
			display: block;
			width: 150px;
			height: 150px;
			margin: 0 auto;
		}

		&__product-title {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			width: 100%;
			height: 50%;
			left: 0;
			bottom: 0;
			padding: 1em;
			background: rgba(#dfe6ef, 0.75);
			overflow: hidden;
			text-align: center;
			word-break: keep-all;
			line-height: 1.25em;
			color: #000;
		}

		&__remove-button {
			position: absolute;
			width: 22px;
			height: 22px;
			background: $red;
			border-radius: 50%;
			z-index: 99;
			right: 0.5em;
			top: 0.5em;
			box-shadow: 2px 2px 1px 0 rgba(0, 0, 0, 0.8);

			&:focus {
				box-shadow: 0 0 2px 3px rgba($btn-blue, 0.8);
			}

			&:after {
				content: '';
				display: block;
				position: absolute;
				width: 3px;
				height: 3px;
				top: 50%;
				left: 50%;
				transform: translate3d(-50%, -50%, 0) rotate(45deg);
				background: #fff;
				box-shadow:
					0 3px 0 0 #fff,
					0 6px 0 0 #fff,
					3px 0 0 0 #fff,
					6px 0 0 0 #fff,
					0 -3px 0 0 #fff,
					0 -6px 0 0 #fff,
					-3px 0 0 0 #fff,
					-6px 0 0 0 #fff;
			}
		}
	}
</style>
